/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliInstitutionGradeDtoIEnumerableApiResponse } from '../../models/amoxcalli-institution-grade-dto-i-enumerable-api-response';

export interface ApiInstitutionGradesGet$Plain$Params {
  institutionId?: string;
}

export function apiInstitutionGradesGet$Plain(http: HttpClient, rootUrl: string, params?: ApiInstitutionGradesGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AmoxcalliInstitutionGradeDtoIEnumerableApiResponse>> {
  const rb = new RequestBuilder(rootUrl, apiInstitutionGradesGet$Plain.PATH, 'get');
  if (params) {
    rb.query('institutionId', params.institutionId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AmoxcalliInstitutionGradeDtoIEnumerableApiResponse>;
    })
  );
}

apiInstitutionGradesGet$Plain.PATH = '/api/institution-grades';
